import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class stockStore {

    // PROPERTIES

    @observable outOfStocks = [];
    @observable showUpdateStockModal = undefined;
    @observable taskId = undefined;
    @observable taskName = undefined;
    @observable category = undefined;
    @observable minimumStock = undefined;
    @observable currentStock = undefined;
    
    @observable updateLoading = false;

    // ACTIONS

    @action init() {
        this.taskId = undefined;
        this.setShowUpdateStockModal(false);

        return ApiCaller.CmsTasks.outOfStocks().then(resp => {
            if (resp) {
                this.outOfStocks = resp;
            } else {
                this.outOfStocks = [];
            }
            
            this.updateLoading = false;
        })
    }

    @action initUpdate() {
        return ApiCaller.CmsTasks.getById(this.taskId).then(resp => {
            if (!resp.isError) {
                if (resp.data) {
                    this.taskName = resp.data.taskName;
                    this.category = resp.data.parentName;
                    this.minimumStock = resp.data.minimumStock;
                    this.currentStock = resp.data.minimumStock;
                }
            } else {
                console.log('Error: (Stock Store - initUpdate) Failed to get item by task id.');
                this.taskName = undefined;
                this.category = undefined;
                this.minimumStock = undefined;
                this.currentStock = undefined;
            }
        })
    }

    @action updateStock() {
        this.updateLoading = true;

        return ApiCaller.CmsTasks.outOfStockUpdate(this.taskId, this.currentStock).then(() => {
            this.init();
        })
    }

    // SET PROPERTIES

    @action setTaskId(value) { 
        this.taskId = value;
    }

    @action setStock(value) { 
        this.currentStock = value;
    }

    @action setShowUpdateStockModal(value) {
        this.showUpdateStockModal = value;
    }
}

export default new stockStore()